let isFilterTrackingActive = false;
(function () {
    if (document.querySelector('#category-top-slider')) {
        initCategoryTopSlider();
    }

    document.querySelectorAll('a.sort-price').forEach(function (el) {
        el.addEventListener('click', function (e) {
            const triValue = this.getAttribute('data-sort');
            const priceSortChoice = document.getElementById('price-sort-filter');

            document.querySelector('#apply-filters').setAttribute('is-processing', '');

            if (priceSortChoice) {
                priceSortChoice.setAttribute('data-price-sort', triValue);
            }
            document.querySelectorAll('.sort-price').forEach(function (triEl) {
                triEl.removeAttribute('is-selected');
            });
            this.setAttribute('is-selected', '');
            if (typeof generateNewBlocProd === 'function') {
                generateNewBlocProd.call(this.form, 0);
            }
        });
    });

    /* Back to top */
    enableBackToTop();
    document.addEventListener('scroll', enableBackToTop);

    /**
     * Category SEO txt read more
     */
    const textSeoRayon = document.querySelector(".text-seo-rayon");
    if (textSeoRayon) {
        const read_more = document.querySelector(".read_more");
        const read_less = document.querySelector(".read_less");

        read_more.addEventListener("click", function () {
            textSeoRayon.removeAttribute("is-trimed");
            read_more.classList.add("cache");
            read_less.classList.remove("cache");
        });

        read_less.addEventListener("click", function () {
            textSeoRayon.setAttribute("is-trimed", "");
            read_more.classList.remove("cache");
            read_less.classList.add("cache");
        });
    }
})();

function paginationGoToPage(page) {
    page = page || 1;
    const page_bloc = parseInt(page - 1);

    if (document.getElementById('search-page')) {
        generateNewBlocSearch(page_bloc, null, null, null, null);
    } else {
        generateNewBlocProd(page_bloc, null, null, null);
    }
}

function paginate(page) {
    const form = document.getElementById('filter-form');
    if (!form) return;

    const total_element = Number(document.querySelector('#totalElems')?.value || 0);
    const nb_prod = Number(document.querySelector('#nb_prod')?.value || 0);
    const nb_total_page = nb_prod ? Math.ceil(total_element / nb_prod) : 0;
    const pagination = document.querySelectorAll('.pager_wrapper');
    const nb_prod_default = Number(document.querySelector('#nb_prod_default')?.value || 0);
    const see_all = document.querySelector('#see_all')?.value || '';
    page = page || 1;

    const url = (typeof path_relative_root === 'string' ? path_relative_root : '') + 'ajax_reload_pagination.php'
        + `?page=${encodeURIComponent(page)}`
        + `&link=${encodeURIComponent('paginationGoToPage()')}`
        + `&nb_total_page=${encodeURIComponent(nb_total_page)}`;

    fetch(url, { method: 'GET', credentials: 'same-origin' })
        .then(res => res.text())
        .then(res => {
            const productLoaded = document.querySelectorAll('.item-product:not(.push)').length;
            const percentLoaded = total_element ? (productLoaded * 100 / total_element) : 0;

            pagination.forEach(function (el) {
                if (nb_prod !== 1000 && nb_prod < total_element) {
                    el.innerHTML = `${res}
                    <div class="nbProdDisplayed">
                        ${Translator.translate('pagination_displayed')} ${productLoaded} ${Translator.translate('pagination_total')} ${total_element}
                    </div>
                    <div class="loadedGauge">
                        <span style="width: ${percentLoaded}%;"></span>
                    </div>
                    <div class="see_all_product"></div>`;
                } else if (total_element >= nb_prod_default) {
                    el.innerHTML =
                        `<div class="nbProdDisplayed">
                            ${Translator.translate('pagination_displayed')} ${productLoaded} ${Translator.translate('pagination_total')} ${total_element}
                        </div>
                        <div class="loadedGauge">
                            <span style="width: ${percentLoaded}%;"></span>
                        </div>
                        <div class="see_all_product"></div>`;
                } else {
                    el.innerHTML = '';
                }
            });
        })
        .catch(err => {
            console.error('[paginate] Network error:', err);
        });
}

function triggerFilter(page, type, idObj, nb_product, formId, fromPagination, search, navigationTypeIsScroll) {
    if (search === undefined) search = '';

    const form = (this instanceof HTMLFormElement) ? this : document.getElementById(formId);
    const ctrl = Array.prototype.slice.call(form.elements, 0);

    // --- Helper natif pour récupérer une valeur de formulaire ---
    const fd = new FormData(form);
    const val = (name, parser) => {
        const v = fd.get(name);
        if (v === null || v === '') return undefined;
        if (typeof parser === 'function') {
            const p = parser(v);
            return (typeof p === 'number' && Number.isNaN(p)) ? undefined : p;
        }
        return v;
    };

    // --- Remplace getParameterByName par URLSearchParams ---
    const urlParamsObj = new URLSearchParams(window.location.search);
    const currentKeyword = urlParamsObj.get('keyword');

    type = type || val('type');
    idObj = idObj || val('idObj');

    const output = {};
    const output_filter = {};
    const selectedFiltersRaw = {}; // <-- new : raw selected filters for DataLayer
    let is_from_page = false;
    let key;

    if (formId === 'filter-form') {
        nb_product = nb_product || val('nb_prod', parseFloat);
        page = (page !== undefined) ? page : val('page', parseFloat);
    }

    const urlParams = {};

    // --- Build active filters ---
    ctrl.forEach(function (elm) {
        if (elm.type === 'checkbox' || elm.type === 'radio') {
            if (elm.checked && elm.name !== 'sscat' && elm.value !== '') {
                if (output[elm.name] === undefined) output[elm.name] = [];

                if (elm.name === 'custom_data') {
                    if (output_filter[elm.dataset.parentname] === undefined) output_filter[elm.dataset.parentname] = [];
                } else {
                    if (elm.name !== '') {
                        if (output_filter[elm.name] === undefined) output_filter[elm.name] = [];
                    }
                }

                if (elm.name === 'custom_data') {
                    let custom_data;
                    custom_data = (elm.getAttribute('data-parent') || '') + '_' + elm.value;
                    output[elm.name].push(custom_data);
                    output_filter[elm.dataset.parentname].push(elm.dataset.name);

                    // --- selectedFiltersRaw pour custom_data ---
                    const keySF = elm.dataset.parentname;
                    if (!selectedFiltersRaw[keySF]) selectedFiltersRaw[keySF] = [];
                    selectedFiltersRaw[keySF].push({
                        id: custom_data,          // même id que dans output.custom_data
                        value: elm.dataset.name   // label lisible
                    });
                } else {
                    if (elm.name !== '') {
                        output[elm.name].push(parseFloat(elm.value));
                        const label = (search === 'search') ? elm.value : elm.dataset.name;

                        if (search === 'search') {
                            output_filter[elm.name].push(elm.value);
                        } else {
                            output_filter[elm.name].push(elm.dataset.name);
                        }

                        // --- selectedFiltersRaw for classic filters ---
                        const keySF = elm.name;
                        if (!selectedFiltersRaw[keySF]) selectedFiltersRaw[keySF] = [];
                        selectedFiltersRaw[keySF].push({
                            id: elm.value,  // id = value de l’input (avant parse)
                            value: label    // label = data-name ou value en mode search
                        });
                    }
                }
            }
        }
    });

    if (formId === 'filter-form' && typeof addFilter === "function") {
        const block = document.querySelector('#block_selected_filter');
        if (block) block.innerHTML = '';

        if (val('price_min', parseFloat) != (document.querySelector('input[type=hidden][name=initial_min_price]')?.value)
            || val('price_max', parseFloat) != (document.querySelector('input[type=hidden][name=initial_max_price]')?.value)) {
            addFilter(val('price_min', parseFloat) + ' - ' + val('price_max', parseFloat), 'priceRange');
        }

        for (key in output) {
            if (Object.prototype.hasOwnProperty.call(output, key)) {
                if (output[key].constructor === Array) {
                    for (let v in output[key]) {
                        const cls = key + '_' + output[key][v];
                        const node = document.querySelector('.' + cls);
                        const name = node ? node.getAttribute('title') : '';
                        const id = key + '_' + output[key][v];
                        addFilter(name, id);
                    }
                }
            }
        }

        if (document.querySelector('#block_selected_filter') && document.querySelector('#block_selected_filter').innerHTML !== '') {
            const span = document.createElement('span');
            span.className = 'remove_filter';
            span.textContent = Translator.translate('remove_all_filters');
            document.querySelector('#block_selected_filter').appendChild(span);
            document.querySelectorAll('.remove_filter').forEach(el => el.addEventListener('click', deleteAllFilter));
        }
    }

    // --- Promo ---
    const promoEl = form?.elements?.['promo'];
    const promoVal = val('promo');
    if (promoEl && typeof promoVal !== "undefined" && promoVal !== '' && document.querySelector('input[name="promo"]')?.getAttribute('type') === 'hidden') {
        output.promo = promoVal;
        output.multi_object = 1;
    }

    // --- Convert arrays to strings ---
    for (key in output) {
        if (Object.prototype.hasOwnProperty.call(output, key)) {
            if (output[key].constructor === Array) output[key] = output[key].join('~');
        }
    }

    if (formId === 'filter-form') {
        if (nb_product !== undefined) {
            form.nb_prod.value = nb_product;
        } else {
            nb_product = form.nb_prod.value;
        }
    }

    if (page !== undefined && page !== 'all') {
        form.page.value = page * nb_product;
        is_from_page = true;
    }

    output.page = form.page.value;
    if (page > 0) {
        output_filter['page'] = [];
        output_filter['page'].push(page + 1);

        // --- selectedFiltersRaw for page ---
        if (!selectedFiltersRaw.page) selectedFiltersRaw.page = [];
        selectedFiltersRaw.page.push({
            id: page + 1,
            value: page + 1
        });
    }

    output.type = type;
    output.parentPath = path_relative_root;
    output.nb_prod = nb_product;
    output.is_page = is_from_page;
    output.nb_tot_prod = form.totalElems.value;
    output.current_page = page + 1;

    if (typeof output.categorie !== "undefined") {
        output.idObj = output.categorie;
        output.multi_object = 1;
        output.type = 'obj';
    } else {
        output.idObj = idObj;
    }

    if (String(idObj).split('~').length > 1) {
        output.multi_object = true;
    }

    if (document.getElementById('select_date')) {
        output.date = 4;
    }

    const arrayOrder = [];
    arrayOrder[1] = 'asc';
    arrayOrder[2] = 'desc';
    arrayOrder[3] = 'title-asc';
    arrayOrder[4] = 'title-desc';
    arrayOrder[5] = 'new';
    arrayOrder[6] = 'sales';

    if (document.getElementById('choice_tri') && document.getElementById('choice_tri').value != '0') {
        output.tri = document.getElementById('choice_tri').value;
        output_filter['order'] = [];
        output_filter['order'].push(arrayOrder[output.tri]);

        // --- selectedFiltersRaw for order / tri ---
        selectedFiltersRaw.order = [{
            id: output.tri,               // id = input value
            value: arrayOrder[output.tri] // readable label
        }];
    }

    // --- Facet price conditions (facet pages) ---
    // Read from the hidden input "facet_price" rendered by wrapper_filters.php / object_index.php.
    // Without it the reload drops the price condition of the facet page and returns the whole level.
    // Not exposed in output_filter/selectedFiltersRaw: it belongs to the page, not to the visitor.
    let facetPriceRaw = null;
    if (form && form.facet_price && form.facet_price.value) {
        facetPriceRaw = form.facet_price.value;
    } else {
        const facetPriceInput = document.getElementById('facet_price');
        if (facetPriceInput && facetPriceInput.value) {
            facetPriceRaw = facetPriceInput.value;
        }
    }
    if (facetPriceRaw) {
        try {
            const facetPrice = JSON.parse(facetPriceRaw);
            if (facetPrice && Object.keys(facetPrice).length > 0) {
                // Sent as the raw JSON string on purpose: this output is serialized with
                // URLSearchParams, which flattens any nested value to "[object Object]"
                // (cf. selected_filters in the reload URL). AjaxController accepts the JSON
                // string as well as the exploded facet_price[0][operator] form.
                output.facet_price = facetPriceRaw;
            }
        } catch (e) {}
    }

    // --- Price ---
    if (document.querySelector('input[name="price_min"]')) {
        let priceMin, priceMax;
        try {
            priceMin = (form.price_min && form.price_min.value) ? form.price_min.value : val('price_min', parseFloat);
            priceMax = (form.price_max && form.price_max.value) ? form.price_max.value : val('price_max', parseFloat);
        } catch (error) {
            priceMin = parseFloat(document.getElementById('amount1')?.value || '0');
            priceMax = parseFloat(document.getElementById('amount2')?.value || '0');
        }

        if (priceMin != (document.querySelector('input[name="initial_min_price"]')?.value) || priceMax != (document.querySelector('input[name="initial_max_price"]')?.value)) {
            output.prix = priceMin + '~' + priceMax;
            output_filter['price'] = [];
            output_filter['price'].push(priceMin);
            output_filter['price'].push(priceMax);

            // --- selectedFiltersRaw for price ---
            selectedFiltersRaw.price = [
                { id: priceMin, value: priceMin },
                { id: priceMax, value: priceMax }
            ];
        }
    }

    // --- Build URL params and normalized selected filters for DataLayer ---
    const normalizedSelectedFilters = {}; // normalized keys (color, size, price, order, etc.)

    for (const current_filter in output_filter) {
        let currentLabelFilter;
        switch (current_filter) {
            case 'couleur': currentLabelFilter = 'color'; break;
            case 'taille': currentLabelFilter = 'size'; break;
            case 'eclat': currentLabelFilter = 'label'; break;
            case 'promo': currentLabelFilter = 'brand'; break;
            case 'custom_data': currentLabelFilter = 'custom_data'; break;
            case 'tri':
                if (arrayOrder[output.tri] !== undefined) {
                    currentLabelFilter = 'order';
                    output_filter['tri'] = [arrayOrder[output.tri]];
                    break;
                } else {
                    continue;
                }
            default: currentLabelFilter = current_filter; break;
        }

        if (current_filter === 'page' && page <= 0) continue;

        urlParams[currentLabelFilter] = decodeURIComponent(output_filter[current_filter].join("~"));

        // Map selectedFiltersRaw to normalized keys
        if (selectedFiltersRaw[current_filter]) {
            normalizedSelectedFilters[currentLabelFilter] = selectedFiltersRaw[current_filter];
        }
    }

    // --- Final selected_filters for output ---
    output.selected_filters = normalizedSelectedFilters;

    if (typeof navigationTypeIsScroll !== "undefined") {
        urlParams['navigationTypeIsScroll'] = navigationTypeIsScroll;
    }
    if (page <= 0) {
        delete urlParams.page;
    }

    /**
     * Preserve existing query params
     * while allowing filters to overwrite values
     */
    const existingParams = new URLSearchParams(window.location.search);

    /**
     * Merge current URL params into urlParams
     * without overwriting already-defined filter params
     */
    for (const [key, value] of existingParams.entries()) {
        if (!(key in urlParams)) {
            urlParams[key] = value;
        }
    }

    /**
     * Preserve keyword if needed
     */
    if (currentKeyword && !urlParams.keyword) {
        urlParams.keyword = currentKeyword;
    }

    /**
     * Build final query string safely
     */
    let finalQueryString = new URLSearchParams(urlParams).toString();
    finalQueryString = finalQueryString ? '?' + finalQueryString : ''; // add '?' in front


    /**
     * Build final URL
     */
    const finalUrl = window.location.pathname + finalQueryString;

    /**
     * Update browser URL
     */
    if (typeof window.paginationIsFromPopState === 'boolean' && window.paginationIsFromPopState === true) {
        window.history.replaceState(urlParams, '', finalUrl);
    } else {
        window.history.pushState(urlParams, '', finalUrl);
    }

    // --- DataLayer V3 ---
    if (typeof dataLayer_v3 !== 'undefined' && dataLayer_v3 !== '' && dataLayer_v3 !== null && !isFilterTrackingActive) {
        DataLayerTrigger.filerInteraction(finalQueryString);
        isFilterTrackingActive = true;
        // Reset the lock after a short delay to allow the next intentional user interaction
        setTimeout(() => {
            isFilterTrackingActive = false;
        }, 500);
    }

    return output;
}

// Keep the outer var if something else relies on it, but it's unused here.
let bloc_prod_xhr;

/**
* Drop-in replacement. Same signature/behavior, but:
* - No param shadowing
* - Uses fetch + robust guards
* - Safer numeric coercion
* - Better null checks & error handling
*/
async function generateNewBlocProd(
    pageArg,
    typeArg,
    idObjArg,
    nbProductArg,
) {
    let fromFilter = false;
    if (pageArg == 0 && typeArg === undefined) {
        fromFilter = true; // note: still not used elsewhere, preserved
    }

    const btnApplyFilters = document.querySelector('#apply-filters');
    const btnResetFilters = document.querySelector('#reset-filters');

    if (fromFilter) {
        if (btnApplyFilters) {
            btnApplyFilters.setAttribute('is-processing', '');
        }
        if (btnResetFilters) {
            btnResetFilters.setAttribute('is-processing', '');
        }
    }

    var form = (this instanceof HTMLFormElement) ? this : document.getElementById('filter-form'),
        pageArg = (typeof pageArg !== 'undefined') ? pageArg : (form.querySelector('[name="page"]') ? parseFloat(form.querySelector('[name="page"]').value) : undefined),
        typeArg = (typeof typeArg !== 'undefined') ? typeArg : (form.querySelector('[name="type"]') ? form.querySelector('[name="type"]').value : undefined),
        idObjArg = (typeof idObjArg !== 'undefined') ? idObjArg : (form.querySelector('[name="idObj"]') ? form.querySelector('[name="idObj"]').value : undefined),
        nbProduct = $('.item-product.stockToCheck').length
        nbProductArg = (typeof nbProductArg !== 'undefined') ? nbProductArg : (form.querySelector('[name="nb_prod"]') ? parseFloat(form.querySelector('[name="nb_prod"]').value) : undefined);

    // Build request params via your existing trigger
    let output = {};

    output = triggerFilter(pageArg, typeArg, idObjArg, nbProductArg, 'filter-form');

    // Filters selected by user, returned by triggerFilter function
    const selected_filters = output.selected_filters || {};
    output.page = nbProduct;
    // Update users selected filters in top page
    document.querySelector('.active-filters-recap')?.setAttribute('is-processing', '');
    updateCategorySelectedFilters(selected_filters);

    const listItem = document.querySelector('#list-item');
    if (!listItem) {
        console.warn('[generateNewBlocProd] #list-item not found');
        return;
    }

    // ✅ jQuery -> natif
    if (fromFilter) {
        output.page = 0;
    } else {
        output.page = listItem.querySelectorAll('.item-product.stockToCheck').length;
    }
    output.handle_push = 'false';

    const params = new URLSearchParams(output).toString();
    const url = (typeof path_relative_root === 'string' ? path_relative_root : '') + 'ajax_reload_products.php?' + params;

    let resText = '';
    try {
        const res = await fetch(url, { method: 'GET',headers: {'X-Requested-With': 'XMLHttpRequest'}, credentials: 'same-origin' });
        if (!res.ok) {
            console.error('[generateNewBlocProd] HTTP error:', res.status, res.statusText);
            return;
        }
        resText = await res.text();
    } catch (err) {
        console.error('[generateNewBlocProd] Network error:', err);
        return;
    }

    // Expected format: joined with '><><'
    const parts = resText.split('><><');
    const content = (parts[0] || '').trim();

    // Safely coerce itm_length
    const itmLength = Number(parts[1] ?? NaN);

    // SEO-related link elements (indices preserved from original)
    const canonical = parts[5] ?? '';
    const prev = parts[6] ?? '';
    const next = parts[7] ?? '';

    // Alternate languages—guard JSON parse
    let alternateEn = '';
    try {
        const alt = JSON.parse(parts[8] ?? '{}');
        alternateEn = alt?.en || '';
    } catch {
        // ignore
    }

    // Update SEO links if present
    try {
        const canonicalHref = (typeof path_relative_root === 'string' ? path_relative_root : '') + canonical;

        const canonicalLink = document.querySelector("link[rel='canonical']");
        if (canonicalLink && canonical) canonicalLink.setAttribute('href', canonicalHref);

        const alternateFr = document.querySelector("link[rel='alternate'][hreflang^='fr-fr']");
        if (alternateFr && canonical) alternateFr.setAttribute('href', canonicalHref);

        const alternateEnLink = document.querySelector("link[rel='alternate'][hreflang='en']");
        if (alternateEnLink && alternateEn) alternateEnLink.setAttribute('href', alternateEn);

        const alternateDefault = document.querySelector("link[rel='alternate'][hreflang='x-default']");
        if (alternateDefault && alternateEn) alternateDefault.setAttribute('href', alternateEn);

        const hrefPrev = document.querySelector("link[rel='prev']");
        const hrefNext = document.querySelector("link[rel='next']");
        const commentPrev = document.getElementById('href_prev');
        const commentNext = document.getElementById('href_next');

        if (typeof changeSeoElement === 'function') {
            changeSeoElement(prev, hrefPrev, commentPrev, 'prev');
            changeSeoElement(next, hrefNext, commentNext, 'next');
        }
    } catch (e) {
        console.warn('[generateNewBlocProd] SEO link update failed', e);
    }

    let availableFiltersData = {};
    try {
        availableFiltersData = JSON.parse(parts[9] ?? '{}');
    } catch {
        // ignore
    }

    const availableFilters = Object.entries(availableFiltersData);

    if (availableFilters.length > 0) {
        for (const [filterType, filterValue] of availableFilters) {
            switch(filterType) {
                case 'sizes':
                    const sizeFilter = document.querySelector('#size-filter');

                    // Hide all sizes
                    sizeFilter.querySelectorAll('label').forEach((sizeLabel) => {
                        sizeLabel.style = 'display: none;';
                    })

                    // Only show the available sizes
                    filterValue.forEach((sizeId) => {
                        const sizeSelector = '[for=size-filter-' + sizeId + ']';
                        const sizeLabel = sizeFilter.querySelector(sizeSelector);
                        if (sizeLabel) {
                            sizeLabel.style = '';
                        }
                    })
                    break;
                case 'colors':
                    const colorFilter = document.querySelector('#color-filter');

                    // Hide all colors
                    colorFilter.querySelectorAll('label').forEach((colorLabel) => {
                        colorLabel.style = 'display: none;';
                    })

                    // Only show the available colors
                    filterValue.forEach((colorId) => {
                        const colorSelector = '[for=color-filter-' + colorId + ']';
                        const colorLabel = colorFilter.querySelector(colorSelector);
                        if (colorLabel) {
                            colorLabel.style = '';
                        }
                    })
                    break;
                case 'customs_data':
                    const customsDataFiltersElements = document.querySelectorAll('.filter-options[id^="customdata-filter"]');

                    // Hide all the customs data filters
                    customsDataFiltersElements.forEach((customsDataFilter) => {
                        const wrapper = customsDataFilter.parentElement;
                        wrapper.style = 'display: none;';
                    });

                    const customsDataFilters = Object.entries(filterValue);

                    // Only show the available sizes
                    customsDataFilters.forEach((customsDataFilter) => {
                        const customsDataName = customsDataFilter[0];
                        const customsDataValues = customsDataFilter[1];

                        if (!customsDataName || !customsDataValues?.length) {
                            return;
                        }

                        const customsDataParent = document.querySelector(`[data-parentname="${customsDataName}"]`);

                        if (!customsDataParent) {
                            return;
                        }

                        const customsDataElement = customsDataParent.parentElement.parentElement;
                        customsDataElement.style = '';

                        customsDataElement.querySelectorAll('label').forEach((element) => {
                            element.style.display = 'none';
                        });

                        customsDataValues.forEach((value) => {
                            const customsDataInput = customsDataElement.querySelector(`[value="${value}"]`);

                            if (!customsDataInput) {
                                return;
                            }

                            const customsDataLabel = customsDataElement.querySelector(`[for="${customsDataInput.id}"]`);

                            if (!customsDataLabel) {
                                return;
                            }

                            customsDataLabel.style = '';
                        });
                    });
                    break;
                case 'objects':
                    const objectFilter = document.querySelector('#categories-filter');

                    if (!objectFilter) {
                        continue;
                    }

                    // Hide all colors
                    objectFilter.querySelectorAll('label').forEach((objectLabel) => {
                        objectLabel.style = 'display: none;';
                    })

                    // Only show the available objects
                    filterValue.forEach((objectId) => {
                        const objectSelector = '[for=category-filter-' + objectId + ']';
                        const objectLabel = objectFilter.querySelector(objectSelector);
                        if (objectLabel) {
                            objectLabel.style = '';
                        }
                    })
                    break;
                case 'eclats_1':
                    const eclatFilter = document.querySelector('#promo-filter');

                    if (!eclatFilter) {
                        continue;
                    }
                        // Hide all colors
                    eclatFilter.querySelectorAll('label').forEach((eclatLabel) => {
                        eclatLabel.style = 'display: none;';
                    })

                    // Only show the available eclats
                    filterValue.forEach((eclatId) => {
                        const eclatSelector = '[for=label-filter-' + eclatId + ']';
                        const eclatLabel = eclatFilter.querySelector(eclatSelector);
                        if (eclatLabel) {
                            eclatLabel.style = '';
                        }
                    })
                    break;
            }
        }
    }

    const paginationButton = document.querySelector('.pagination-button');
    if (paginationButton) {
        paginationButton.setAttribute('is-processing', '');
    }

    if (content !== '') {
        if (!Number.isNaN(pageArg)) {
            listItem.setAttribute('data-product-displayed', String(pageArg * nbProductArg));
        }

        listItem.classList.remove('no-result');

        if (fromFilter) {
            listItem.innerHTML = ''; // Clear existing products only if this was triggered by a filter action (pageArg=0 + typeArg undefined), otherwise append for pagination
        }

        // Update total elements + pagination
        const totalElemsInput = document.getElementById('totalElems');
        if (totalElemsInput && !Number.isNaN(itmLength)) {
            totalElemsInput.value = String(itmLength);
        }

        listItem.setAttribute('data-total-products', String(itmLength));

        if (typeof paginate === 'function') {
            // pageArg might be NaN; default to 0
            const nextPage = Number.isFinite(pageArg) ? pageArg + 1 : 1;
            paginate(nextPage);
        }

        listItem.insertAdjacentHTML('beforeend', content);

        const evt = new CustomEvent('newBlocGenerated');
        window.dispatchEvent(evt);

        if (
            (typeof checkItemsStock === 'function') &&
            (typeof query_stock_in_cache === 'boolean' && query_stock_in_cache === true)
        ) {
            checkItemsStock();
        }
    } else {
        const emptyHtml =
            `<div class="no-result-wrapper">
            ${Translator.translate('no_result_txt')}
        </div>`;

        const paginationWrapper = document.querySelector('.pagination-wrapper');
        paginationWrapper ? paginationWrapper.classList.add('no-result') : null;
        listItem.classList.add('no-result');
        listItem.innerHTML = emptyHtml;
    }

    // -------- onloadend equivalent (runs after content is applied) --------
    try {
        const paginationProdDisplayed = document.querySelector('.pagination-prod-displayed');
        const productLoaded = listItem.querySelectorAll('.item-product:not(.push)').length;

        const totalProductsAttr = Number(listItem.getAttribute('data-total-products') || '0');
        const totalProducts = Number.isFinite(totalProductsAttr) ? totalProductsAttr : 0;

        // Update totalProducts in title
        if (document.querySelector('.category-main-title .category-main-title-results')) {
            document.querySelector('.category-main-title .category-main-title-results').textContent =
                `${totalProducts}`;
        }

        const paginationProgress = document.querySelector('.pagination-progress');

        if (paginationProdDisplayed) {
            paginationProdDisplayed.innerHTML =
                `${Translator.translate('pagination_displayed')} ${productLoaded} ` +
                `${Translator.translate('pagination_total')} ${totalProducts}`;
        }

        if (paginationProgress) {
            let prog = paginationProgress.querySelector('progress');
            if (!prog) {
                prog = document.createElement('progress');
                paginationProgress.textContent = '';
                paginationProgress.appendChild(prog);
            }
            prog.setAttribute('value', String(productLoaded));
            prog.setAttribute('max', String(totalProducts));
        }

        if (paginationButton) {
            if (productLoaded >= totalProducts && totalProducts > 0) {
                paginationButton.setAttribute('is-hidden', '');
            } else {
                paginationButton.removeAttribute('is-hidden');
                paginationButton.removeAttribute('is-processing');
            }
        }

        if (btnApplyFilters) {
            btnApplyFilters.removeAttribute('is-processing');
        }
        if (btnResetFilters) {
            btnResetFilters.removeAttribute('is-processing');
        }

        // #totalElems
        const totalElemsEl = document.getElementById('totalElems');
        if (totalElemsEl) {
            totalElemsEl.dispatchEvent(new Event('change'));
        }

        // #page
        const pageEl = document.getElementById('page');
        if (pageEl) {
            pageEl.dispatchEvent(new Event('change'));
        }
    } catch (e) {
        console.warn('[generateNewBlocProd] pagination UI update failed', e);
        if (paginationButton) {
            paginationButton.removeAttribute('is-hidden');
            paginationButton.removeAttribute('is-processing');
        }
    }

    document.querySelector('.active-filters-recap')?.removeAttribute('is-processing');
}

let tempo_reset = false;

function initAllFilters(event) {
    // Use the form this was bound to, or fall back to #filter-form
    const form = (event?.currentTarget instanceof HTMLFormElement)
    ? event.currentTarget
    : (this instanceof HTMLFormElement)
    ? this
    : document.getElementById('filter-form');

    let isFacetPage = (form.closest('#filters-modal')?.classList.contains('facet_page'));
    let parentPath = form.closest('#filters-modal')?.getAttribute('data-parent-path');

    if (!form) return; // nothing to reset

    // If this is a facet page with a parent path, navigate back to the parent instead of trying to reset filters in the facet context
    if (isFacetPage && parentPath) {
        window.location.href = parentPath;
        return;
    }

    const btnResetFilters = document.querySelector('#reset-filters');
    if (btnResetFilters) {
        btnResetFilters.setAttribute('is-processing', '');
    }

    const controls = Array.from(form.elements || []);

    // Reset all controls before triggering a single product reload.
    for (const el of controls) {
        if ((el.type === 'checkbox' || el.type === 'radio')
            && el.checked
        && el.name !== 'sscat'
        && el.value !== '') {
            el.checked = false;
            el.classList.remove('is_checked');
        }
    }

    // Clear active sort links
    for (const a of document.querySelectorAll('a.sort-price[is-selected]')) {
        a.removeAttribute('is-selected');
    }

    // Reset sorting select (if present)
    const priceSortChoice = document.getElementById('price-sort-filter');
    if (priceSortChoice) {
        priceSortChoice.setAttribute('data-price-sort', '0');
    }

    // Flag reset and refresh products
    tempo_reset = true;
    if (typeof generateNewBlocProd === 'function') {
        // Keep the original call context + argument
        generateNewBlocProd.call(form, 0);
    }
}

/* Example: bind to a "Reset filters" button or the form itself
document.getElementById('reset-filters-btn')?.addEventListener('click', initAllFilters);
// or
document.getElementById('filter-form')?.addEventListener('reset', initAllFilters);
*/

function enableBackToTop() {
    const btn = document.querySelector('.site-back-to-top');
    if (!btn) return;

    const threshold = window.innerHeight; // 100vh

    if (window.scrollY > threshold) {
        btn.hasAttribute('is-hidden') ? btn.removeAttribute('is-hidden') : null;
    } else {
        btn.hasAttribute('is-hidden') ? null : btn.setAttribute('is-hidden', '');
    }
}

function backToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
}

function toggleInternalLinks() {
    const internalLinksBtn = document.querySelector('.internal-links-button');
    const internalLinks = document.querySelector('.internal-links');
    if (internalLinks.hasAttribute('is-hidden')) {
        internalLinksBtn.setAttribute('is-opened', '');
        internalLinks.removeAttribute('is-hidden');
        slideDown(internalLinks, 500, 'flex');
    } else {
        slideUp(internalLinks, 500);
        internalLinksBtn.removeAttribute('is-opened');
        internalLinks.setAttribute('is-hidden', '');
    }
}

document.addEventListener('DOMContentLoaded', function () {

    // Check if filters are active on page load
    const pageArg = document.querySelector('#filters-form [name="page"]') ? parseFloat(document.querySelector('#filters-form [name="page"]').value) : 0;
    const typeArg = document.querySelector('#filters-form [name="type"]') ? document.querySelector('#filters-form [name="type"]').value : undefined;
    const idObjArg = document.querySelector('#filters-form [name="idObj"]') ? document.querySelector('#filters-form [name="idObj"]').value : undefined;
    const nbProductArg = document.querySelector('#filters-form [name="nb_prod"]') ? parseFloat(document.querySelector('#filters-form [name="nb_prod"]').value) : undefined;

    let pageLoadedOutput = triggerFilter(pageArg, typeArg, idObjArg, nbProductArg, 'filter-form');

    const selected_filters = pageLoadedOutput.selected_filters || {};

    if (Object.keys(selected_filters).length > 0) {
        updateCategorySelectedFilters(selected_filters);
    }
});

/* Update active filters display */
function updateCategorySelectedFilters(filters) {
    const container = document.querySelector('.active-filters-recap .filters-recap');

    if (!container) return;

    if (Object.keys(filters).length > 0) {
        document.querySelector('.active-filters-recap').removeAttribute('is-hidden');
    } else {
        document.querySelector('.active-filters-recap').setAttribute('is-hidden', '');
        return;
    }

    // Updating filters based on provided filters object (create items for each filter)
    Object.entries(filters).forEach(([key, value]) => {
        value.forEach(filter => {

            let real_filter;

            if (document.querySelector(`[value="${filter.value}"]`) && document.querySelector(`[value="${filter.value}"]`).getAttribute('name') == 'custom_data') {
                // custom data special case
                real_filter = document.querySelector(`[value="${filter.id.split('_').slice(1).join('_')}"][data-parentname="${key}"]`);
            } else {

                if (key == 'object') {
                    key = 'category';
                }

                real_filter = document.querySelector('#' + key + '-' + 'filter' + '-' + filter.id);
            }

            if (!real_filter) {
                console.warn(`Filtre ignoré : ${key} / id=${filter.id} (introuvable dans le DOM)`);
                return; // <-- go to next iteration if filter not found
            }

            // Do not add facet-only entries to the active filters recap.
            if (real_filter.hasAttribute('is-facet')) {
                return;
            }

            let filter_template = document.createElement('div');
            let filter_name = document.createElement('span');
            let filter_remove = document.createElement('span');

            // Determine actual filter type and id that will be used
            const actualFilterType = real_filter.getAttribute('name') == 'custom_data' ? real_filter.getAttribute('data-name') : key;
            const actualFilterId = real_filter.getAttribute('name') == 'custom_data' ? real_filter.getAttribute('id') : filter.id;

            if (document.querySelector(`.active-filters-recap .filters-recap .filter-item[data-filter-type="${actualFilterType}"][data-filter-id="${actualFilterId}"]`)) {
                return; // prevents duplicates, go to next iteration
            }

            filter_template.classList.add('filter-item');
            filter_template.setAttribute('data-filter-type', actualFilterType); // use input name for better consistency, fallback to key
            filter_template.setAttribute('data-filter-value', real_filter.getAttribute('name') == 'custom_data' ? real_filter.getAttribute('data-parentname') : filter.value);
            filter_template.setAttribute('data-filter-id', actualFilterId);
            if (real_filter.getAttribute('name') == 'custom_data') {
                filter_template.setAttribute('is-customdata', '');
            }
            filter_name.classList.add('filter-name');
            filter_remove.classList.add('filter-remove');

            let filterName = real_filter.getAttribute('name') == 'custom_data' ? real_filter.getAttribute('data-name') : filter.value;
            // Special case for label filter to replace trailing dash with "All"
            if (key == 'label') {
                filterName = filterName.replace(/-$/, "%");
            }
            filter_name.textContent = filterName;
            filter_remove.textContent = '×';
            filter_remove.setAttribute('data-filter-type', real_filter.getAttribute('name') == 'custom_data' ? real_filter.getAttribute('data-name') : key); // use input name for better consistency, fallback to key
            filter_remove.setAttribute('data-filter-value', real_filter.getAttribute('name') == 'custom_data' ? real_filter.getAttribute('data-parentname') : filter.value);
            filter_remove.setAttribute('data-filter-id', real_filter.getAttribute('name') == 'custom_data' ? real_filter.getAttribute('id') : filter.id);

            // Add name and remove to template
            filter_template.appendChild(filter_name);
            filter_template.appendChild(filter_remove);

            container.appendChild(filter_template);

            filter_template.addEventListener('click', function (e) {
                e.preventDefault();

                real_filter.click();
            });
        });
    });

    // Clear filters that are no longer active (In case user has unchecked some filters, this function will also be called to update the display)
    const activeFilterItems = container.querySelectorAll('.filter-item');
    activeFilterItems.forEach(item => {
        const filterType = item.getAttribute('data-filter-type');
        const filterId = item.getAttribute('data-filter-id');
        const isCustomData = item.hasAttribute('is-customdata');
        const correspondingFilter = isCustomData ? document.querySelector(`#${filterId}`) : document.querySelector(`#${filterType}-filter-${filterId}`);
        if (!correspondingFilter || !correspondingFilter.checked || correspondingFilter.hasAttribute('is-facet')) {
            item.remove();
        }
    });

    const recapWrapper = document.querySelector('.active-filters-recap');
    if (recapWrapper) {
        const hasVisibleFilters = container.querySelectorAll('.filter-item').length > 0;
        if (hasVisibleFilters) {
            recapWrapper.removeAttribute('is-hidden');
        } else {
            recapWrapper.setAttribute('is-hidden', '');
        }
    }
}
